export default __webpack_public_path__ + "static/media/paytm.c6c0b954.svg";